let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cWuNK")).then(() => parcelRequire('6H8qL'));